import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SelectType from 'pages/mobile/bind/SelectType';
import Individual from 'pages/mobile/bind/Individual';
import Corporate from 'pages/mobile/bind/Corporate';
import Sales from 'pages/mobile/bind/Sales';
import IndividualSuccess from 'pages/mobile/bind/IndividualSuccess';
import CorporateSuccess from 'pages/mobile/bind/CorporateSuccess';
import SalesSuccess from 'pages/mobile/bind/SalesSuccess';

const BindRouter = () => {
  return (
    <Routes>
      <Route path="/SelectType" element={<SelectType />}></Route>
      <Route path="/Individual" element={<Individual />}></Route>
      <Route path="/Corporate" element={<Corporate />}></Route>
      <Route path="/Sales" element={<Sales />}></Route>
      <Route path="/IndividualSuccess" element={<IndividualSuccess />}></Route>
      <Route path="/CorporateSuccess" element={<CorporateSuccess />}></Route>
      <Route path="/SalesSuccess" element={<SalesSuccess />}></Route>
    </Routes>
  );
};

export default BindRouter;
